import React from 'react';

export const ToolTipClone = (title, itemsList) => (
  <div className=" apexcharts-theme-light">
    <div
      className="apexcharts-tooltip-title"
      style={{
        fontFamily: 'Open Sans, Helvetica Neue, sans-serif',
        fontSize: '12px',
      }}
    >
      {title}
    </div>

    {itemsList.map((item, idx) => (
      <div
        key={idx}
        className="apexcharts-tooltip-series-group apexcharts-active"
        style={{ display: 'flex' }}
      >
        <span
          className="apexcharts-tooltip-marker"
          style={{ backgroundColor: item.colour }}
        ></span>
        <div
          className="apexcharts-tooltip-text"
          style={{
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontSize: '12px',
          }}
        >
          <div className="apexcharts-tooltip-y-group">
            <span className="apexcharts-tooltip-text-label">
              {item.label}:{' '}
            </span>
            <span className="apexcharts-tooltip-text-value">
              {item.value}
            </span>
          </div>
          <div className="apexcharts-tooltip-z-group">
            <span className="apexcharts-tooltip-text-z-label"></span>
            <span className="apexcharts-tooltip-text-z-value"></span>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const ToolTipAnomaly = (title, itemsList, anomalyList) => (
  <div className=" apexcharts-theme-light">
    <div
      className="apexcharts-tooltip-title"
      style={{
        fontFamily: 'Helvetica, Arial, sans-serif',
        fontSize: '12px',
      }}
    >
      {title}
    </div>
    {itemsList.map((item, idx) => (
      <div
        key={idx}
        className="apexcharts-tooltip-series-group apexcharts-active"
        style={{ display: 'flex' }}
      >
        <span
          className="apexcharts-tooltip-marker"
          style={{ backgroundColor: item.colour }}
        ></span>
        <div
          className="apexcharts-tooltip-text"
          style={{
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontSize: '12px',
          }}
        >
          <div className="apexcharts-tooltip-y-group">
            <span className="apexcharts-tooltip-text-label">
              {item.label}:{' '}
            </span>
            <span className="apexcharts-tooltip-text-value">
              {item.value}
            </span>
          </div>
          <div className="apexcharts-tooltip-z-group">
            <span className="apexcharts-tooltip-text-z-label"></span>
            <span className="apexcharts-tooltip-text-z-value"></span>
          </div>
        </div>
      </div>
    ))}
    {anomalyList.map((item, idx) => (
      <div
        key={idx}
        className="apexcharts-tooltip-series-group apexcharts-active"
        style={{ display: 'flex' }}
      >
        <div
          className="apexcharts-tooltip-text"
          style={{
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontSize: '12px',
          }}
        >
          <div className="apexcharts-tooltip-y-group">
            <span className="apexcharts-tooltip-text-label">
              {item.label}
            </span>
          </div>
          <div className="apexcharts-tooltip-z-group">
            <span className="apexcharts-tooltip-text-z-label"></span>
            <span className="apexcharts-tooltip-text-z-value"></span>
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const ToolTipPercent = (
  title,
  itemsList,
  percentOnly,
  percentOnly2,
) => (
  <div className=" apexcharts-theme-light">
    <div
      className="apexcharts-tooltip-title"
      style={{
        fontFamily: 'Helvetica, Arial, sans-serif',
        fontSize: '12px',
      }}
    >
      {title}
    </div>
    {itemsList.map((item, idx) => (
      <div
        key={idx}
        className="apexcharts-tooltip-series-group apexcharts-active"
        style={{ display: 'flex' }}
      >
        <span
          className="apexcharts-tooltip-marker"
          style={{ backgroundColor: item.colour }}
        ></span>
        <div
          className="apexcharts-tooltip-text"
          style={{
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontSize: '12px',
          }}
        >
          <div className="apexcharts-tooltip-y-group">
            <span className="apexcharts-tooltip-text-label">
              {item.label}:{' '}
            </span>
            {percentOnly ? (
              <span className="apexcharts-tooltip-text-value">
                {item.value}%
              </span>
            ) : (idx === 1) & !percentOnly2 ? (
              <span className="apexcharts-tooltip-text-value">
                {item.value}%
              </span>
            ) : (
              <span className="apexcharts-tooltip-text-value">
                {item.value}
              </span>
            )}
          </div>
          <div className="apexcharts-tooltip-z-group">
            <span className="apexcharts-tooltip-text-z-label"></span>
            <span className="apexcharts-tooltip-text-z-value"></span>
          </div>
        </div>
      </div>
    ))}
  </div>
);
